import {useQueryClient} from '@tanstack/react-query';
import {memo, useEffect} from 'react';
import {Outlet} from 'react-router';

import {PREFETCH_QUERIES} from '#queries/config.js';
import {prefetchQueries} from '#queries/utils.js';
import {useFeatureFlag} from '#stores/session/index.js';

import {Shell} from './components/shell/index.js';

export const AuthenticatedLayout = memo(function AuthenticatedLayout() {
  const isReactSPALayoutEnabled = useFeatureFlag('reactSPALayout');
  const queryClient = useQueryClient();

  useEffect(() => {
    if (isReactSPALayoutEnabled) {
      prefetchQueries(queryClient, PREFETCH_QUERIES);
    }
  }, [queryClient, isReactSPALayoutEnabled]);

  if (!isReactSPALayoutEnabled) {
    return <Outlet />;
  }

  return (
    <Shell>
      <Outlet />
    </Shell>
  );
});
